import React from 'react';
import './Preloader.css';
import logo from '../assets/acm_logo.png';

const Preloader = () => {
  return (
    <div className="preloader">
      <div className="loader-logo">
        <img src={logo} alt="Loading..." />
      </div>
    </div>
  );
};

export default Preloader;